import { useAppSelector } from '../hooks';
import { type IEvent, selectEventBySlug } from '../reducers/eventsSlice';

export function useEvent(eventSlug: string | undefined): { event: IEvent | undefined } {
  const event = useAppSelector((state) => (eventSlug ? selectEventBySlug(state, eventSlug) : undefined));
  return { event };
}
